export * from "@/utils/capacitor";
export const isOnTest = import.meta.env.VITE_AUTH_ENV === "ontest";
export const isDev = import.meta.env.VITE_NODE_ENV === "development";
